import { AnnualHolidayRule } from '@act/shared/types';

export const REEMA_OBSERVED_HOLIDAYS: readonly AnnualHolidayRule[] = [
  { kind: 'fixed', month: 1, day: 1, name: "New Year's Day" },
  {
    kind: 'floating',
    month: 1,
    weekday: 1,
    occurrence: 3,
    name: 'Martin Luther King Jr. Day',
  },
  {
    kind: 'floating',
    month: 11,
    weekday: 4,
    occurrence: 4,
    name: 'Thanksgiving Day',
  },
  { kind: 'fridayAfterThanksgiving', name: 'Day after Thanksgiving' },
  {
    kind: 'floating',
    month: 5,
    weekday: 1,
    occurrence: 'last',
    name: 'Memorial Day',
  },
  {
    kind: 'floating',
    month: 9,
    weekday: 1,
    occurrence: 1,
    name: 'Labor Day',
  },
  { kind: 'fixed', month: 6, day: 19, name: 'Juneteenth' },
  { kind: 'fixed', month: 7, day: 4, name: 'Independence Day' },
  { kind: 'fixed', month: 12, day: 25, name: 'Christmas Day' },
  { kind: 'fixed', month: 12, day: 24, name: 'Christmas Eve' },
];
